//#region types
import { CustomerFormContainerProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region  components
import CustomerCreateForm from "./createForm";
import useCustomerCreateHelpers from "./sections/create/useCustomerCreateHelpers";
//#endregion

const CustomerCreateFormContainer: React.FC<CustomerFormContainerProps> = (props) => {
  const { selectedCustomerChangeHandler, organizationNumberChangeHandler } = props;

  const { handleSubmit, defaultValues, getValidationSchema } = useCustomerCreateHelpers(props);

  return (
    <CustomerCreateForm
      {...props}
      getValidationSchema={getValidationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
      organizationNumberChangeHandler={organizationNumberChangeHandler}
      selectedCustomerChangeHandler={selectedCustomerChangeHandler}
      isCreate
      canToggleActiveStatus={false}
      customerName={props.customerName}
    />
  );
};

export default CustomerCreateFormContainer;
